<template>
    <div class="list_item" @click="goDetailPage">
        <!-- IMAGE start -->
        <div class="item_cell cell">
            <div class="image_container">
                <img-box
                    class="image"
                    :src="cellData.previewPicture"
                    :errorImg="errorImg"
                    :alt="$ft.formatAddr(cellData.address)"
                >
                </img-box>
                <!-- <site-img class="image" :src="item.previewPicture" alt="" /> -->
                <div class="amount_container">
                    <span class="iconfont icon-new-photo"></span>
                    <span class="amount">{{ cellData.picturesNum }}</span>
                </div>
                <VerifyMask v-if="isShowMask" />
            </div>
        </div>
        <!-- IMAGE end  -->
        <!-- Address  start -->
        <div class="item_cell cell">
            <div class="address">
                <a :href="cellData.link" rel="noopener noreferrer">{{
                    !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                }}</a>
            </div>
        </div>
        <!-- Address end -->
        <!-- Sold Date start -->
        <div class="item_cell cell">
            <only-client>
                <span class="text_common">{{
                    $ft.formatDate(new Date(cellData.listDate), 'MM/dd/yyyy')
                }}</span>
            </only-client>
        </div>
        <!-- Sold Date end -->
        <!-- Property Type start -->
        <div class="item_cell cell">
            <span class="text_common">{{ cellData.propertyType }}</span>
        </div>
        <!-- Property Type end -->
        <!-- CONFIGURE start -->
        <div class="item_cell cell">
            <div class="text_common">
                <div>
                    {{
                        $t('md-listing-list.bed0', { count: !isShowMask ? cellData.bedrooms : '***' })
                    }}
                </div>
                <div>
                    {{
                        $t('md-listing-list.bath0', {
                            count: !isShowMask ? cellData.bathrooms : '***'
                        })
                    }}
                </div>
                <div>{{ !isShowMask ? cellData.sqft : '*** ' + $t('md-listing-list.sqft') }}</div>
            </div>
        </div>
        <!-- CONFIGURE end -->
        <!-- Sold PRICE start -->
        <div class="item_cell cell">
            <div class="sold_price t_right">
                <template v-if="!isShowMask">
                    <template v-if="showPrice">
                        <div class="price">
                            {{
                                $ft.formatUnitNum(
                                    cellData.showPrice,
                                    false,
                                    0,
                                    currencySymbol
                                )
                            }}
                        </div>
                        <div
                            class="tendency"
                            :class="{
                                up: cellData.status > 0,
                                down: cellData.status < 0
                            }"
                        >
                            <div v-if="cellData.status !== 0">
                                <span
                                    class="iconfont"
                                    :class="{
                                        'icon-trend-up': cellData.status > 0,
                                        'icon-trend-down': cellData.status < 0
                                    }"
                                ></span>
                                <span>{{ changePriceNum }}</span>
                            </div>
                        </div>
                    </template>
                    <div v-else class="empty-price">--</div>
                </template>
                <PriceMask v-else />
            </div>
        </div>
        <!-- Sold PRICE end -->
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';
export default {
    name: 'table-item',
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-pc.standard{
    /* table layout structure and title The style settings for  start */
    .list_item {
        display: table-row;
        justify-content: space-between;
        cursor: pointer;
        .cell {
            display: table-cell;
        }
        .item_cell {
            padding: 20px 0;
            border-bottom: 1px solid var(--color-border);
            height: 100%;
            vertical-align: middle;
        }
        .t_right {
            text-align: right;
        }
    }
    /* table layout structure and title The style settings for  end */
    /* item_cell  The style settings under  start */
    .item_cell {
        .image_container {
            width: 160px;
            height: 96px;
            position: relative;
            .image {
                width: 100%;
                height: 100%;
            }
            .amount_container {
                position: absolute;
                top: 0;
                right: 0;
                height: 30px;
                width: 50px;
                color: #fff;
                font-size: 14px;
                background: rgba(0, 0, 0, 0.2);
                border-bottom-left-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                .amount {
                    margin-left: 7px;
                }
            }
        }
        .address {
            padding-right: 30px;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            font-size: 16px;
            line-height: 1.5;
            color: var(--color-label);
            a:hover {
                text-decoration: underline;
            }
        }
        .text_common {
            font-size: 14px;
            line-height: 20px;
            color: var(--color-info);
        }
        .sold_price {
            .price {
                font-size: 16px;
                font-weight: bold;
                line-height: 1.25;
                color: var(--color-text);
                margin-bottom: 6px;
            }
            .tendency {
                font-size: 12px;
                font-weight: bold;
                .iconfont {
                    font-size: 8px;
                }
                &.up {
                    color: #96efb4;
                }
                &.down {
                    color: #ffb8b4;
                }
            }
            .empty-price {
                font-size: 16px;
            }
        }
    }
    /* item_cell  The style settings under  end */
}
</style>
